export default __webpack_public_path__ + "static/media/house.f57bebb6.svg";